import getApiClient from '@/plugins/api-client'
import Vue from 'vue'
import { formatDate } from '@/util/helpers'

export default {
  loadNotification () {
    const api = getApiClient(this.$store)
    const id = this.$route.params.id

    api.get(`dashboard_notifications/${id}`)
      .then(result => {
        if (!result.data.showFrom) {
          result.data.showFrom = null
        }

        if (!result.data.showUntil) {
          result.data.showUntil = null
        }

        this.notification = result.data

        if (this.notification.showFrom) {
          this.formattedShowFrom = formatDate(new Date(this.notification.showFrom))
        }

        if (this.notification.showUntil) {
          this.formattedShowUntil = formatDate(new Date(this.notification.showUntil))
        }
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.notification.id ? 'patch' : 'post'
    const options = {}

    let endpoint = 'dashboard_notifications'

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.notification['@id']
    }

    const payload = {
      title: this.notification.title,
      content: this.notification.content,
      showFrom: this.notification.showFrom,
      showUntil: this.notification.showUntil,
      roles: this.notification.roles,
      enabled: this.notification.enabled,
    }

    for (const key in Object.keys(payload)) {
      if (!payload[key]) {
        delete payload[key]
      }
    }

    api[method](endpoint, payload, options)
      .then(result => {
        this.user = result.data
        this.$store.commit('app/raiseSuccess', 'Notificação salva com sucesso')
        this.$router.push({
          name: 'DashboardNotifications',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar notificação')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },
}
